(() => {
  const initializeDeck = (deck) => {
    if (!deck || deck.dataset.deckInitialized === 'true') return;

    const track = deck.querySelector('[data-category-deck-track]');
    const cards = Array.from(track?.querySelectorAll('.collection-list__item') || []);
    if (!track || cards.length === 0) return;

    deck.dataset.deckInitialized = 'true';
    deck.classList.add('category-deck--ready');

    let updateFrame;
    const updateActiveCard = () => {
      window.cancelAnimationFrame(updateFrame);
      updateFrame = window.requestAnimationFrame(() => {
        const trackRect = track.getBoundingClientRect();
        const trackCenter = trackRect.left + trackRect.width / 2;
        let activeCard = cards[0];
        let closestDistance = Number.POSITIVE_INFINITY;

        cards.forEach((card) => {
          const cardRect = card.getBoundingClientRect();
          const cardCenter = cardRect.left + cardRect.width / 2;
          const distance = Math.abs(trackCenter - cardCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            activeCard = card;
          }
        });

        cards.forEach((card) => {
          const isActive = card === activeCard;
          card.classList.toggle('is-active', isActive);
          card.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      });
    };

    track.addEventListener('scroll', updateActiveCard, { passive: true });
    window.addEventListener('resize', updateActiveCard, { passive: true });

    let pointerId;
    let startX = 0;
    let startScrollLeft = 0;
    let didDrag = false;
    let suppressClick = false;

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      didDrag = false;
      
      // REMOVED setPointerCapture from here
    });

    track.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const movement = event.clientX - startX;

      if (Math.abs(movement) > 5) {
        if (!didDrag) {
          // Triggered only once per drag
          didDrag = true;
          track.classList.add('is-dragging');
          
          // ADDED: Only capture the pointer if we are actually dragging
          track.setPointerCapture(pointerId); 
        }
      }

      if (!didDrag) return;
      event.preventDefault();
      track.scrollLeft = startScrollLeft - movement;
    });

    const endDrag = (event) => {
      if (event.pointerId !== pointerId) return;

      if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);
      pointerId = undefined;
      track.classList.remove('is-dragging');

      if (didDrag) {
        suppressClick = true;
        window.setTimeout(() => {
          suppressClick = false;
        }, 100);
      }

      updateActiveCard();
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    updateActiveCard();
  };

  const initializeAllDecks = (root = document) => {
    if (root.matches?.('[data-category-deck]')) initializeDeck(root);
    root.querySelectorAll?.('[data-category-deck]').forEach(initializeDeck);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllDecks());
  } else {
    initializeAllDecks();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAllDecks(event.target));
})();